module.exports = __webpack_public_path__ + "static/media/tailoring-2575930_1920.7453ba04.jpg";